module.exports = __webpack_public_path__ + "static/media/monresto.99a3c1b2.svg";